import script from "./CustomFieldsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldsTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldsTable.vue?vue&type=style&index=0&id=2b02b0b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b02b0b4"]])

export default __exports__